import { useCallback } from 'react';
import ReactGA from 'react-ga';

export const useGaEvent = () => {
  return useCallback((p: { category: string; action: string; label: string }) => {
    ReactGA.event(p);
  }, []);
};
